import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledGroceryInput } from '@/models/scheduledGrocery';

export const createScheduledGrocery = async (data: ScheduledGroceryInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateScheduledGrocery($data: ScheduledGroceryInputType!) {
        createScheduledGrocery(data: $data) {
          id
        }
      }
    `),
    variables: {
      data,
    },
  });

  return !!response.data?.createScheduledGrocery;
};
